<template>
  <a
    class="d-leaderboard-feed-entry grid grid-no-response border-bottom no-decoration"
    :href="userProfileUrl"
  >
    <div class="avatar">
      <DLeaderboardFeedEntryBadge
        :position="entry.position"
      />
      <img
        :src="entry.avatar_url"
        :alt="entry.name"
      >
    </div>

    <div class="user-info grid grid-no-response">
      <p class="username large font-alt">
        {{ entry.name }}
      </p>

      <p class="ellipsis">{{ entry.genres }}</p>
    </div>

    <div class="grid-flex grid-no-response buttons-wrapper">
      <DFollowButton
        v-once
        class="button button-sm"
        :is-following="entry.is_following"
        :user-id="entry.id"
      />
    </div>
  </a>
</template>

<script>
import DFollowButton from '@d-components/d-follow-button/d-follow-button.vue';
import DLeaderboardFeedEntryBadge from '@d-components/d-leaderboard-feed/d-leaderboard-feed-entry-badge/d-leaderboard-feed-entry-badge.vue';
import URLS from '@d-shared/urls/urls';

export default {
  components: {
    DLeaderboardFeedEntryBadge,
    DFollowButton,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userProfileUrl() {
      return URLS.app.userProfile.entry.replace('<username>', this.entry.username);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-leaderboard-feed-entry {
  align-items: start;
  grid-template-columns: $_8em 1fr $_12em;
  grid-template-areas: 'avatar user-info buttons';
  grid-gap: $_2em;
  padding: $_2em 0;

  :last-child {
    border-bottom: none;
  }

  .avatar {
    grid-area: avatar;
    position: relative;

    img {
      border-radius: 50%;
      display: block;
      height: $_8em;
      width: $_8em;
    }
  }

  .user-info {
    grid-area: user-info;

    .username {
      margin: 0;
    }
  }

  .buttons-wrapper {
    grid-area: buttons;
    justify-content: flex-end;
  }
}
</style>
